<pre>
    {{arrayListadoAromia|json}}
</pre>